import React, { useEffect, useState } from 'react';
import NoIndex from '../../components/NoIndex';
import '../auth/login/tokens.css';
import Styles from './styles.module.css';
import Icon from './../../image/icon_black.png';

import DefaultImage from './../../image/default/account.png';

import Manual from './1.manual/index';
import JobPostings from './2.jobPostings/index';
import JobPostingEdit from './2.jobPostings/edit/index';
import JobPostingSending from './2.jobPostings/sending/index';
import Recruit from './3.recruit/index';
import MidCareerRecruit from './17.midCareer/recruit/index';
import MidCareerRecruitEdit from './17.midCareer/recruit/edit/index';
import MidCareerJobPostings from './17.midCareer/jobPostings/index';
import MidCareerJobPostingEdit from './17.midCareer/jobPostings/edit/index';
// import Manage from './6.manage/index'; // 応募・選考は一旦コメントアウト
import Graduate from './4.graduation/index';
import Setting from './8.setting/index';
import Loading from './loading/index';
import SalonPr from './10.salonPr/index';
import VisitInfo from './18.visitInfo/index';
import Score from './13.score/index';
import StudentWorks from './14.studentWorks/index';
import Evaluation from './15.evaluation/index';
import Judging from './16.judging/index';
import JudgeShell from './judgeShell/index';
import PaidPlanGate from './PaidPlanGate';
import { BsWindowDesktop } from "react-icons/bs";
import { IoPeopleOutline, IoSettingsOutline, IoMenuOutline, IoHeartOutline, IoClipboardOutline, IoMegaphoneOutline, IoDocumentTextOutline, IoOpenOutline, IoLockClosed, IoChevronDown, IoWalkOutline } from "react-icons/io5";
import { MID_CAREER_POSITIONS, MidCareerPositionSlug } from './17.midCareer/positions';
import { BsPersonUp } from "react-icons/bs";
import { IoStarOutline } from "react-icons/io5";

import { useAppSelector } from '../app/hook';
import { Routes, Route, Navigate, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { unsavedGuard, UnsavedGuardModal } from './unsavedGuard';

// 無料プランで各画面を開いたときに中身の代わりに出すロック案内の文面。
// ナビ自体は隠さず「有料にしないと使えません」を見せる方針(アプリと同じ)。
const PAID_GATE = {
  recruit: '写真・数字・スタッフインタビューを使って「ここで働くとどうなるか」が伝わる求人ページを作り、学生の応募につなげる機能です。',
  studentWorks: '学生の作品撮りにいいねを送ることで、スタイルの一致を学生に伝え、御社の求人ページの閲覧・応募につなげる機能です。',
  evaluation: '応募者を一覧で管理し、審査員の評価や選考の進み具合をまとめて確認できる機能です。',
  judging: '応募者の資料を見ながら審査員が評価を提出し、社内で選考の目線をそろえられる機能です。',
  score: '求人ページの充実度を項目ごとに点数化し、学生の目に留まりやすくするための改善ポイントが分かる機能です。',
  visitInfo: '見学の担当者・当日のスケジュール・受付枠を登録し、学生の「行く前の不安」を減らしてサロン見学につなげる機能です。',
} as const;

const RECRUIT_GATE_FEATURES = [
  '写真・数字・インタビューを使った求人ページの作成',
  '全国210校すべての美容学校への求人票の送付',
  '応募者管理・審査・求人スコア など採用ツール一式',
];

const Service: React.FC = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const company = useAppSelector((state) => state.company.company);
  const isCompleted = !!company?.progress?.plan && !!company?.progress?.icon && !!company?.progress?.jobPostings && !!company?.progress?.sending && !!company?.progress?.complete;

  // ログイン直後の着地先。オンボーディング未完了なら manual、完了済みなら
  // 契約有無に応じて 求人スコア / サロンPR。index ルートのリダイレクトと同じ判定。
  // ※ ここを "/service/setting" にすると、ログイン直後(manualパス経由)に必ず
  //   設定画面へ飛ばされてしまう。
  const homePath = isCompleted
    ? (company.contract ? "/service/score" : "/service/salonPr")
    : "/service/manual/plan";

  useEffect(() => {
    // 審査員セッションはjudgeShellが常にjudgingを表示するため、
    // このパス検証(オーナー向けの導線チェック)の対象外にする
    if (company.role === 'judge') return;

    const pathname = location.pathname;

    // ルート直下(/service) は index ルートのリダイレクトに任せる。
    // ここで弾くと setting へ飛んでしまい、スコア(や無料プランのsalonPr)に着地できない。
    if (pathname === "/service" || pathname === "/service/") return;

    const validExact = [
      "/service/jobPostings",
      "/service/recruit",
      "/service/midCareer/recruit",
      "/service/midCareer/jobPostings",
      "/service/studentWorks",
      "/service/graduate",
      // "/service/manage", // 応募・選考は一旦コメントアウト
      "/service/evaluation",
      "/service/judging",
      "/service/salonPr",
      "/service/visitInfo",
      "/service/score",
      "/service/setting",
    ];

    const validJobPostingsPrefix = "/service/jobPostings/";
    const validMidCareerRecruitPrefix = "/service/midCareer/recruit/";
    const validMidCareerJobPostingsPrefix = "/service/midCareer/jobPostings/";
    const validManualPrefix = "/service/manual/";

    // manualが完了済みなのにmanualパスにいる場合は、着地先(スコア/サロンPR)へ。
    // (旧実装は setting へ飛ばしており、ログイン直後に必ず設定画面に着地していた)
    if (isCompleted && pathname.startsWith(validManualPrefix)) {
      navigate(homePath, { replace: true });
      return;
    }

    const isValid = validExact.includes(pathname)
      || pathname.startsWith(validManualPrefix)
      || pathname.startsWith(validJobPostingsPrefix)
      || pathname.startsWith(validMidCareerRecruitPrefix)
      || pathname.startsWith(validMidCareerJobPostingsPrefix);

    if (!isValid) {
      navigate(homePath, { replace: true });
    }
  }, [location.pathname, isCompleted, company.role, homePath]);

  const [ isMac, setIsMac ] = useState(false);
  const [ navOpen, setNavOpen ] = useState(false);

  // 採用トラック(コンテキスト)。既定は常に新卒。中途の職種に切り替えると
  // 「求人票の編集」「求人の編集」がその職種向け画面に切り替わり、学校接点
  // (卒業生登録)は隠れる。サロンPR・学生の作品・設定は共通で常時表示。
  // ※ DB連携は別途。ここでは表示コンテキストの切替のみ(既存の仕組みは非変更)。
  // ブラウザ単位で保持し、次回ログイン時も同じコンテキストに着地する。
  type TrackKey = 'newGrad' | MidCareerPositionSlug;
  const [ activeTrack, setActiveTrack ] = useState<TrackKey>('newGrad');
  const [ trackMenuOpen, setTrackMenuOpen ] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('activeTrack');
    if (saved === 'newGrad' || MID_CAREER_POSITIONS.some((p) => p.slug === saved)) {
      setActiveTrack(saved as TrackKey);
    }
  }, []);

  const isMidCareer = activeTrack !== 'newGrad';
  const activeTrackLabel = activeTrack === 'newGrad'
    ? '新卒採用'
    : `中途採用：${MID_CAREER_POSITIONS.find((p) => p.slug === activeTrack)?.label ?? ''}`;

  const selectTrack = (next: TrackKey) => {
    setTrackMenuOpen(false);
    if (next === activeTrack) return;
    setActiveTrack(next);
    localStorage.setItem('activeTrack', next);
    // 切替先コンテキストの中心画面(求人の編集)へ移動する
    navigate(next === 'newGrad' ? '/service/recruit' : `/service/midCareer/recruit/${next}`);
  };

  // 卒業生登録画面は、ヘッダーのアカウント画像の代わりに「追加」ボタンを表示する
  // (表示位置を統一するため)。
  // ※サロンPR(作品/説明会/クーポン/スタッフ)は各タブ自身が「＋」ボタンを持つため、
  //   ここでは管理しない。
  const [ graduateMakeOpen, setGraduateMakeOpen ] = useState(false);

  const headerActionMap: Record<string, { label: string; onClick: () => void }> = {
    graduate: { label: "＋ 卒業生を追加する", onClick: () => setGraduateMakeOpen(true) },
  };

  // ナビゲーション項目の「?」ヒント。キー = ナビの識別子、値 = 段落配列。
  const navHintMap: Record<string, string[]> = {
    jobPostings: [
      "学校へ送付する公式の求人票（PDF）を、卒業年度ごと（2027年卒・2028年卒）に作成する画面です。給与・勤務時間・休日などの募集条件を入力します。",
      "「求人の編集」で作る求人ページとは別物です。求人票は学校へ届き、求人ページは学生がアプリで見ます。どちらも入力が必要です。",
      "内容を確定して送付先の学校を選ぶと、学校へ届きます。",
    ],
    score: [
      "求人ページ（求人の編集）の充実度を項目ごとに点数化し、弱いところを教えてくれる画面です。学生の目に留まりやすくするための改善ポイントを確認できます。",
      "点数はあくまで目安です。AIアドバイスを使うと、具体的な改善の文例も出せます。",
    ],
    recruit: [
      "学生がアプリで最初に見る「求人ページ」を作る画面です。写真・数字・魅力3選・店舗紹介・インタビュー・求める人物像などを入力します。",
      "アプリ上では、ここで作った内容の下に「サロンPR」（スタッフ・会社説明会・クーポン）、さらに下に「求人票」が続いて、1つの求人ページとして表示されます。3つセットで埋めるほど学生に伝わる情報が増えます。",
      "左メニューの項目は1つずつ保存でき、右側のプレビューでアプリでの見え方をその場で確認できます。",
    ],
    salonPr: [
      "「スタッフ」「会社説明会」「クーポン」の3つを登録する画面です。登録した内容は、求人ページ（求人の編集）の下に自動で差し込まれて表示されます。",
      "会社説明会は、登録すると学生がアプリから予約できるようになります。空のままだと、その項目は求人ページに表示されません。",
    ],
    visitInfo: [
      "サロン見学の「担当者」「当日のスケジュール」「受付枠」を登録する画面です。担当者は編集ボタンからモーダルで設定でき、アプリの見学申込ボタンの近くに顔写真とひとことが吹き出しで表示されます。",
      "「当日のスケジュール」はステップごとに所要時間を入れると合計時間が自動計算され、学生が「何時間かかるか」「何を説明されるか」を事前に把握できます。",
      "「見学の受付枠」は曜日ごとの受付時間帯（午前・午後・夜）を登録し、カレンダーで特定の日だけ休止・臨時追加もできます。学生が空いている日から見学先を探せるようになります。",
    ],
    graduate: [
      "御社に在籍している「◯◯学校の卒業生」を登録する画面です。氏名と出身校を入れるだけです。",
      "登録すると、その学校の就職担当が見る画面に「このサロンに自校の卒業生がいる」と表示され、学校からの紹介や信頼につながります。学生アプリには表示されません。",
    ],
    studentWorks: [
      "美容学生がアプリに投稿した作品（ヘアスタイル写真など）を一覧で見られる画面です。",
      "気になる作品に「いいね」を送ると学生に通知が届き、サロンを知ってもらうきっかけになります。応募を待つだけでなく、こちらから反応できる場所です。",
    ],
    evaluation: [
      "御社に応募した学生の一覧と、選考の進み具合を管理する画面です。",
      "審査員を設定しておくと、各審査員がつけた評価がここに集まります。",
    ],
    judging: [
      "審査員として、応募者の資料を確認しながら評価（審査）を提出する画面です。",
      "提出した内容は「応募者管理」に集約されます。",
    ],
    setting: [
      "会社の基本情報・ロゴ・通知などを設定する画面です。ここで登録した情報は求人ページやアプリの表示に反映されます。",
    ],
  };
  navHintMap["midCareer/recruit"] = navHintMap["recruit"];
  navHintMap["midCareer/jobPostings"] = navHintMap["jobPostings"];

  // 開いているヒントのキーと、その吹き出しの表示位置（クリックした「?」の右隣）
  const [ navHintKey, setNavHintKey ] = useState<string | null>(null);
  const [ navHintPos, setNavHintPos ] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
  useEffect(() => { setNavHintKey(null); }, [location.pathname]);

  const toggleNavHint = (key: string) => (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (navHintKey === key) { setNavHintKey(null); return; }
    const r = e.currentTarget.getBoundingClientRect();
    setNavHintPos({
      top: Math.min(r.top, window.innerHeight - 260),
      left: r.right + 10,
    });
    setNavHintKey(key);
  };

  const navHint = (key: string) =>
    navHintMap[key] ? (
      <span
        role="button"
        tabIndex={0}
        aria-label="この画面の使い方"
        className={navHintKey === key ? `${Styles.navHint} ${Styles.navHintActive}` : Styles.navHint}
        onClick={toggleNavHint(key)}
      >?</span>
    ) : null;

  // 無料プランでは開いてもロック案内(PaidPlanGate)になる項目。
  // ナビ上でも薄く＋鍵アイコンを付けて「使える／使えない」を分かるようにする。
  const freeLocked = !company.contract;
  const navLock = freeLocked ? (
    <IoLockClosed className={Styles.nav_lock_icon} aria-label="有料プラン限定" />
  ) : null;
  const navItemClass = (isActive: boolean) => {
    const base = isActive ? `${Styles.nav_items} ${Styles.active}` : Styles.nav_items;
    return freeLocked ? `${base} ${Styles.nav_locked}` : base;
  };

  const titleMap: Record<string, { title: string; desc: string }> = {
    jobPostings: {
      title: "求人票の編集",
      desc: "年度ごとの求人票を編集",
    },
    recruit: {
      title: "求人編集",
      desc: "写真や数字を使って学生に向けた求人を作成",
    },
    studentWorks: {
      title: "学生の作品",
      desc: "学生が投稿した作品を見て、気になる作品にいいねを送る",
    },
    graduate: {
      title: "卒業生管理",
      desc: "卒業生を入力し学校に対して、卒業生の在籍を伝える",
    },
    // manage: { // 応募・選考は一旦コメントアウト
    //   title: "応募者管理",
    //   desc: "応募者の履歴書管理やメッセージでのやり取りを行う",
    // },
    evaluation: {
      title: "応募者管理",
      desc: "サロン見学・応募の学生の選考状況を管理し、メッセージでやり取りする",
    },
    judging: {
      title: "審査",
      desc: "応募者の資料を確認しながら審査を提出する",
    },
    salonPr: {
      title: "サロンPR",
      desc: "スタッフ、会社説明会、クーポンを登録し、美容学生にサロンの魅力を発信できます。",
    },
    visitInfo: {
      title: "サロン見学情報",
      desc: "見学の担当者・当日のスケジュール・受付枠を登録し、学生の「行く前の不安」を減らします",
    },
    score: {
      title: "求人スコア",
      desc: "求人の充実度をスコアで確認・改善",
    },
    setting: {
      title: "設定・管理",
      desc: "会社の基本情報や通知を設定",
    },
    "midCareer/jobPostings": {
      title: "求人票の編集（中途）",
      desc: "スタイリスト・アシスタントなど中途採用向けの求人票を編集",
    },
    "midCareer/recruit": {
      title: "求人編集（中途）",
      desc: "写真や数字を使って中途採用向けの求人を作成",
    },
  };

  // "/service/jobPostings/2027" のようなネストしたパスでも
  // 親タブ("jobPostings")のタイトルを引けるよう、末尾ではなく
  // "/service/"の直後のセグメントをキーにする。
  // "/service/midCareer/recruit"・"/service/midCareer/jobPostings" は
  // 第2セグメントが共通で"midCareer"になるため、この2つだけ第3セグメントまで見る。
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const pathKey = pathSegments[1] === "midCareer"
    ? `midCareer/${pathSegments[2] ?? ""}`
    : pathSegments[1] ?? "score";
  const current = titleMap[pathKey] ?? {
    title: "",
    desc: "",
  };
  const headerAction = headerActionMap[pathKey];

  useEffect(() => {
    const platform = navigator.platform.toUpperCase();
    setIsMac(platform.includes('MAC'));
  }, []);

  const isWindows = navigator.userAgent.includes("Windows");
  const zoom = isWindows ? 0.8 : 1;

  // company未取得
  if (!company?.id) {
    return <Loading />;
  }

  // 審査員セッション: サイドバー・他機能への導線を一切持たない専用シェルのみ表示する
  if (company.role === 'judge') {
    return <JudgeShell company={company} />;
  }

  return (
    <>
      <NoIndex title="管理画面 | memorii works" />
      <Routes>

        <Route path="manual/*" element={
          <div style={{ zoom, ...(isWindows ? { minHeight: `${100 / zoom}vh` } : {}) }}>
            <Manual companyId={company.id} />
          </div>
        } />

        <Route
          path="/*"
          element={
            <div className={Styles.main}>
              {/* モバイル用ヘッダーバー */}
              <div className={Styles.mobile_header}>
                <img src={Icon} alt="memorii works" className={Styles.mobile_header_logo} />
                <IoMenuOutline className={Styles.mobile_header_menu} onClick={() => setNavOpen(v => !v)} />
              </div>

              {/* モバイル展開時バックドロップ */}
              {navOpen && (
                <div className={Styles.nav_backdrop} onClick={() => setNavOpen(false)} />
              )}

              {/* ナビゲーション */}
              <div
                className={`${Styles.navigation} ${navOpen ? Styles.navigation_open : ''}`}
                style={{
                  zoom,
                  height: isWindows ? `${100 / zoom}vh` : "100vh",
                }}
              >
                <div className={Styles.logo}>
                  <img src={Icon} alt="memorii works ロゴ" />
                  <h1>memorii works</h1>
                </div>

                <div
                  className={Styles.items}
                  onClick={() => setNavOpen(false)}
                  onClickCapture={(e) => {
                    // 求人票の編集などで未保存の変更があるとき、サイドバーの
                    // 別画面リンク(NavLink = <a>)へのクリックを確認モーダルで止める。
                    // 未保存でなければ何もせず NavLink 本来の遷移に任せる。
                    if (!unsavedGuard.isDirty()) return;
                    const anchor = (e.target as HTMLElement).closest('a');
                    const href = anchor?.getAttribute('href');
                    if (!href || href === location.pathname) return;
                    e.preventDefault();
                    e.stopPropagation();
                    unsavedGuard.request(() => navigate(href));
                  }}
                >

                  {/* 採用トラック(コンテキスト)切替。
                      新卒採用／中途採用：スタイリスト／中途採用：アシスタントの切替UIは
                      次のアップデートで有効化する。それまで非表示。 */}
                  {false && (
                  <div className={Styles.trackSwitch}>
                    <button
                      type="button"
                      className={Styles.trackSwitch_btn}
                      aria-haspopup="listbox"
                      aria-expanded={trackMenuOpen}
                      onClick={(e) => { e.stopPropagation(); setTrackMenuOpen((v) => !v); }}
                    >
                      <span className={Styles.trackSwitch_label}>{activeTrackLabel}</span>
                      <IoChevronDown className={Styles.trackSwitch_caret} />
                    </button>
                    {trackMenuOpen && (
                      <div
                        className={Styles.trackSwitch_scrim}
                        onClick={(e) => { e.stopPropagation(); setTrackMenuOpen(false); }}
                      />
                    )}
                    {trackMenuOpen && (
                      <div className={Styles.trackSwitch_menu} role="listbox">
                        <button
                          type="button"
                          className={activeTrack === 'newGrad' ? `${Styles.trackSwitch_opt} ${Styles.trackSwitch_optActive}` : Styles.trackSwitch_opt}
                          onClick={(e) => { e.stopPropagation(); selectTrack('newGrad'); }}
                        >新卒採用</button>
                        {MID_CAREER_POSITIONS.map((p) => (
                          <button
                            key={p.slug}
                            type="button"
                            className={activeTrack === p.slug ? `${Styles.trackSwitch_opt} ${Styles.trackSwitch_optActive}` : Styles.trackSwitch_opt}
                            onClick={(e) => { e.stopPropagation(); selectTrack(p.slug); }}
                          >中途採用：{p.label}</button>
                        ))}
                        <button
                          type="button"
                          className={`${Styles.trackSwitch_opt} ${Styles.trackSwitch_optAdd}`}
                          disabled
                          title="準備中"
                        >＋ 職種を追加</button>
                      </div>
                    )}
                  </div>
                  )}

                  {/* 求人スコア（両コンテキスト） */}
                  <NavLink
                    to="/service/score"
                    end
                    className={({ isActive }) => navItemClass(isActive)}
                  >
                    <IoStarOutline className={Styles.nav_items_icons} />
                    <p>求人スコア</p>
                    {navLock}
                    {navHint("score")}
                  </NavLink>

                  {/* 求人・情報発信 */}
                  <p className={Styles.navCategory}>求人・情報発信</p>

                  <NavLink
                    to={isMidCareer ? `/service/midCareer/jobPostings/${activeTrack}` : "/service/jobPostings"}
                    /* end を付けない: 年度別の編集画面(/service/jobPostings/:year, /:year/sending)
                       にいる間も「求人票の編集」をアクティブ(青)表示にする。
                       「求人の編集」(/service/recruit ちょうど)と同じ挙動に揃える。 */
                    className={({ isActive }) =>
                      isActive ? `${Styles.nav_items} ${Styles.active}` : Styles.nav_items
                    }
                  >
                    <IoDocumentTextOutline className={Styles.nav_items_icons} />
                    <p>求人票の編集</p>
                    {navHint(isMidCareer ? "midCareer/jobPostings" : "jobPostings")}
                  </NavLink>

                  <NavLink
                    to={isMidCareer ? `/service/midCareer/recruit/${activeTrack}` : "/service/recruit"}
                    end
                    className={({ isActive }) => navItemClass(isActive)}
                  >
                    <BsWindowDesktop className={Styles.nav_items_icons} />
                    <p>求人の編集</p>
                    {navLock}
                    {navHint(isMidCareer ? "midCareer/recruit" : "recruit")}
                  </NavLink>

                  <NavLink
                    to="/service/salonPr"
                    end
                    className={({ isActive }) =>
                      isActive ? `${Styles.nav_items} ${Styles.active}` : Styles.nav_items
                    }
                  >
                    <IoMegaphoneOutline className={Styles.nav_items_icons} />
                    <p>サロンPR</p>
                    {navHint("salonPr")}
                  </NavLink>

                  {/* サロン見学情報は新卒のみ（中途採用ではサロン見学の仕組みを使わない） */}
                  {!isMidCareer && (
                    <NavLink
                      to="/service/visitInfo"
                      end
                      className={({ isActive }) => navItemClass(isActive)}
                    >
                      <IoWalkOutline className={Styles.nav_items_icons} />
                      <p>サロン見学情報</p>
                      {navLock}
                      {navHint("visitInfo")}
                    </NavLink>
                  )}

                  {/* 学校接点（新卒のみ） */}
                  {!isMidCareer && (
                    <>
                      <p className={Styles.navCategory}>学校接点</p>

                      <NavLink
                        to="/service/graduate"
                        end
                        className={({ isActive }) =>
                          isActive ? `${Styles.nav_items} ${Styles.active}` : Styles.nav_items
                        }
                      >
                        <BsPersonUp className={Styles.nav_items_icons} />
                        <p>卒業生登録</p>
                        {navHint("graduate")}
                      </NavLink>
                    </>
                  )}

                  {/* 学生との接点（新卒のみ。中途採用では学生の作品導線を出さない） */}
                  {!isMidCareer && (
                    <>
                      <p className={Styles.navCategory}>学生との接点</p>

                      <NavLink
                        to="/service/studentWorks"
                        end
                        className={({ isActive }) => navItemClass(isActive)}
                      >
                        <IoHeartOutline className={Styles.nav_items_icons} />
                        <p>学生の作品</p>
                        {navLock}
                        {navHint("studentWorks")}
                      </NavLink>
                    </>
                  )}

                  {/* 学生の管理（両コンテキスト） */}
                  <p className={Styles.navCategory}>学生の管理</p>

                  <NavLink
                    to="/service/evaluation"
                    end
                    className={({ isActive }) => navItemClass(isActive)}
                  >
                    <IoClipboardOutline className={Styles.nav_items_icons} />
                    <p>応募者管理</p>
                    {navLock}
                    {navHint("evaluation")}
                  </NavLink>
                  <NavLink
                    to="/service/judging"
                    end
                    className={({ isActive }) => navItemClass(isActive)}
                  >
                    <IoClipboardOutline className={Styles.nav_items_icons} />
                    <p>審査</p>
                    {navLock}
                    {navHint("judging")}
                  </NavLink>

                  {/* 設定 */}
                  <p className={Styles.navCategory}>設定</p>

                  <NavLink
                    to="/service/setting"
                    end
                    className={({ isActive }) =>
                      isActive ? `${Styles.nav_items} ${Styles.active}` : Styles.nav_items
                    }
                  >
                    <IoSettingsOutline className={Styles.nav_items_icons} />
                    <p>設定・管理</p>
                    {navHint("setting")}
                  </NavLink>

                </div>

                {/* プレビュー導線（求人票PDF・求人サイト）。新卒コンテキストのみ（_2027データ前提） */}
                {isCompleted && !isMidCareer && (
                  <div className={Styles.previewCard} onClick={() => setNavOpen(false)}>
                    <p className={Styles.previewCard_title}>確認用プレビュー</p>

                    <p className={Styles.previewCard_label}>求人票（2027年卒）</p>
                    <div className={Styles.previewCard_pdfs}>
                      {["20", "18", "17"].map((age) => (
                        <a
                          key={age}
                          className={Styles.previewCard_pdf}
                          href={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsPdf%2F${company.id}_2027_${age}.pdf?alt=media&token=`}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          <IoDocumentTextOutline className={Styles.previewCard_pdf_icon} />
                          {age}歳卒
                        </a>
                      ))}
                    </div>

                    {company.contract && (
                      <a
                        className={Styles.previewCard_link}
                        href={`https://memorii-works.com/recruit/id=${company.id}_2027`}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <IoOpenOutline className={Styles.previewCard_link_icon} />
                        求人サイトのプレビュー
                      </a>
                    )}
                  </div>
                )}
              </div>

              {/* コンテンツ */}
              <div className={Styles.contents} style={{ zoom }}>
                <div className={Styles.contents_title}>
                  <div className={Styles.contents_title_title}>
                    <h2>{current.title}</h2>
                    <h3>{current.desc}</h3>
                  </div>
                  {headerAction ? (
                    <button className={Styles.contents_title_upload} onClick={headerAction.onClick}>
                      {headerAction.label}
                    </button>
                  ) : (
                    <div className={Styles.contents_title_account}>
                      <img className={Styles.make_image_file}
                        src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${company.id}_500x500?alt=media&token=`}
                        onError={e => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = DefaultImage;
                        }}/>
                      <p>{company.name}</p>
                    </div>
                  )}
                </div>

                <Routes>
                  {/* 初期 */}
                  <Route index element={ <Navigate to={homePath} replace /> }/>

                  {/* jobPostings（求人票の編集は無料プランでも利用可） */}
                  <Route path="jobPostings" element={ isCompleted ? (<JobPostings />) : (<Navigate to="/service/manual/plan" replace />) }/>

                  {/* jobPostings edit (年度別) */}
                  <Route path="jobPostings/:year" element={ isCompleted ? (<JobPostingEdit />) : (<Navigate to="/service/manual/plan" replace />) }/>

                  {/* jobPostings 送付先の選択 (年度別) */}
                  <Route path="jobPostings/:year/sending" element={ isCompleted ? (<JobPostingSending />) : (<Navigate to="/service/manual/plan" replace />) }/>

                  {/* recruit */}
                  <Route path="recruit" element={ isCompleted ? (company.contract ? (<Recruit />) : (<PaidPlanGate message={PAID_GATE.recruit} features={RECRUIT_GATE_FEATURES} />)) : (<Navigate to="/service/manual/plan" replace />) }/>

                  {/* 中途採用(スタイリスト/アシスタント)モード。応募者管理・審査は仕組みが
                      変わらないため既存のevaluation/judingルートをそのまま使う。 */}
                  <Route path="midCareer/recruit" element={ isCompleted ? (company.contract ? (<MidCareerRecruit />) : (<Navigate to="/service/setting" replace />)) : (<Navigate to="/service/manual/plan" replace />) }/>
                  <Route path="midCareer/recruit/:position" element={ isCompleted ? (company.contract ? (<MidCareerRecruitEdit />) : (<Navigate to="/service/setting" replace />)) : (<Navigate to="/service/manual/plan" replace />) }/>
                  <Route path="midCareer/jobPostings" element={ isCompleted ? (company.contract ? (<MidCareerJobPostings />) : (<Navigate to="/service/setting" replace />)) : (<Navigate to="/service/manual/plan" replace />) }/>
                  <Route path="midCareer/jobPostings/:position" element={ isCompleted ? (company.contract ? (<MidCareerJobPostingEdit />) : (<Navigate to="/service/setting" replace />)) : (<Navigate to="/service/manual/plan" replace />) }/>

                  {/* studentWorks */}
                  <Route path="studentWorks" element={ isCompleted ? ( company.contract ? ( <StudentWorks /> ) : ( <PaidPlanGate message={PAID_GATE.studentWorks} /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />

                  {/* graduate */}
                  <Route path="graduate" element={ isCompleted ? <Graduate make={graduateMakeOpen} setMake={setGraduateMakeOpen} /> : <Navigate to="/service/manual/plan" replace /> } />

                  {/* manage: 応募・選考は一旦コメントアウト
                  <Route path="manage" element={ isCompleted ? ( company.contract ? ( <Manage /> ) : ( <Setting /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />
                  */}

                  {/* evaluation */}
                  <Route path="evaluation" element={ isCompleted ? ( company.contract ? ( <Evaluation /> ) : ( <PaidPlanGate message={PAID_GATE.evaluation} /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />

                  {/* judging */}
                  <Route path="judging" element={ isCompleted ? ( company.contract ? ( <Judging /> ) : ( <PaidPlanGate message={PAID_GATE.judging} /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />

                  {/* サロンPR(スタッフ紹介・会社説明会・クーポンを1画面3タブに統合) */}
                  <Route path="salonPr" element={ isCompleted ? <SalonPr /> : <Navigate to="/service/manual/plan" replace /> } />

                  {/* サロン見学情報(担当者カード・見学の流れ。空き枠は準備中) */}
                  <Route path="visitInfo" element={ isCompleted ? ( company.contract ? ( <VisitInfo /> ) : ( <PaidPlanGate message={PAID_GATE.visitInfo} /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />

                  {/* score */}
                  <Route path="score" element={ isCompleted ? ( company.contract ? ( <Score /> ) : ( <PaidPlanGate message={PAID_GATE.score} /> )) : ( <Navigate to="/service/manual/plan" replace /> )} />

                  {/* setting */}
                  <Route path="setting" element={isCompleted ? <Setting /> : <Navigate to="/service/manual/plan" replace />} />

                </Routes>

                <div style={{ height: "50px" }} />
              </div>

              {/* ナビの「?」ヒント吹き出し */}
              {navHintKey && navHintMap[navHintKey] && (
                <>
                  <div className={Styles.navHintScrim} onClick={() => setNavHintKey(null)} />
                  <div
                    className={Styles.navHintPopover}
                    style={{ top: navHintPos.top, left: navHintPos.left }}
                  >
                    {navHintMap[navHintKey].map((text, i) => (
                      <p key={i}>{text}</p>
                    ))}
                  </div>
                </>
              )}

              {/* 未保存の編集がある画面から離脱しようとしたときの確認モーダル */}
              <UnsavedGuardModal />
            </div>
          }
        />
      </Routes>
    </>
  );
};

export default Service;
